import { Component } from "@angular/core";
import { MetadataTextButtonComponent } from "./metadata-text-button.component";

@Component({
    selector: "metadata-generic-button",
    templateUrl: "./metadata-generic-button.tmpl.html",
    standalone: false
})
export class MetadataGenericButtonComponent extends MetadataTextButtonComponent
{

    get CanEdit(): boolean
    {
        return !!this.model && this.allowEdit() && !this.viewOnly;
    }

}
